module.exports = __webpack_public_path__ + "img/icon_package1.7143414e.png";